export default class AccordionService {
    initFooterAccordion() {
        const footer = document.getElementById('site-footer');
        if (!footer) {
            return;
        }
        const handleAccordionClick = (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const nextElement = target.nextElementSibling;
            if (!nextElement) {
                return;
            }
            if (nextElement.classList.contains('show')) {
                nextElement.classList.remove('show');
                target.classList.remove('active');
                nextElement.classList.add('d-none');
            }
            else {
                footer === null || footer === void 0 ? void 0 : footer.querySelectorAll('#site-footer .accordion-inner').forEach((accordionInner) => {
                    accordionInner.classList.remove('show');
                    accordionInner.classList.add('d-none');
                });
                footer === null || footer === void 0 ? void 0 : footer.querySelectorAll('#site-footer .accordion-toggle').forEach((accordionToggle) => {
                    accordionToggle.classList.remove('active');
                });
                target.classList.toggle('active');
                nextElement.classList.toggle('show');
                nextElement.classList.remove('d-none');
                if (target.classList.contains('woocommerce-MyAccount-title')) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            }
        };
        footer.querySelectorAll('#site-footer .accordion-toggle').forEach((toggle) => {
            toggle.addEventListener('click', handleAccordionClick);
        });
    }
    initFAQAccordion() {
        const accordions = document.querySelectorAll('faq-block');
        if (!accordions) {
            return;
        }
        const tabs = document.querySelectorAll('[data-faq-tab]');
        const groups = document.querySelectorAll(`[data-faq-group]`);
        const collapseGroupItems = () => {
            const tabGroup = document.querySelectorAll(`.answer-item-content`);
            tabGroup.forEach((el) => {
                el.classList.remove('show');
                el.classList.add('d-none');
            });
        };
        const collapseAllGroups = () => {
            collapseGroupItems();
            tabs.forEach((tab) => {
                tab.classList.remove('active');
            });
            groups.forEach((group) => {
                group.classList.remove('show');
            });
        };
        const showGroupItem = (tabId, index) => {
            const tabGroup = document.querySelectorAll(`[data-faq-group="${tabId}"] .answer-item-content .show`);
            tabGroup.forEach((el) => {
                el.classList.remove('show');
            });
        };
        const handleTabClick = (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const tabId = target.dataset.faqTab;
            if (!tabId) {
                return;
            }
            const tabGroup = document.querySelector(`[data-faq-group="${tabId}"]`);
            if (!tabGroup) {
                return;
            }
            collapseAllGroups();
            showGroupItem(tabId, 1);
            target.classList.add('active');
            tabGroup.classList.add('show');
            console.log(target.dataset.faqTab);
        };
        const handleAccordionClick = (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const nextElement = target.querySelector('.answer-item-content');
            if (!nextElement) {
                return;
            }
            if (nextElement.classList.contains('show')) {
                nextElement.classList.remove('show');
                target.classList.remove('active');
                nextElement.classList.add('d-none');
            }
            else {
                target.classList.toggle('active');
                nextElement.classList.toggle('show');
                nextElement.classList.remove('d-none');
            }
        };
        tabs.forEach((tab) => {
            tab.addEventListener('click', handleTabClick);
        });
        groups.forEach((group) => {
            group.querySelectorAll('.faq-block-list-item').forEach((accordionItem) => {
                accordionItem.addEventListener('click', handleAccordionClick);
            });
        });
    }
    initDeliveryFAQAccordion() {
        const accordions = document.querySelectorAll('delivery-faq-block');
        if (!accordions) {
            return;
        }
        const groups = document.querySelectorAll(`[data-faq-group]`);
        const handleAccordionClick = (e) => {
            const currentTarget = e.currentTarget;
            const target = e.target;
            const nextElement = currentTarget.querySelector('.answer-item-content');
            if (!nextElement) {
                return;
            }
            if (target.closest('a')) {
                return;
            }
            e.preventDefault();
            if (nextElement.classList.contains('show')) {
                nextElement.classList.remove('show');
                currentTarget.classList.remove('active');
                nextElement.classList.add('d-none');
            }
            else {
                currentTarget.classList.toggle('active');
                nextElement.classList.toggle('show');
                nextElement.classList.remove('d-none');
            }
        };
        groups.forEach((group) => {
            group.querySelectorAll('.delivery-faq-block-list-item').forEach((accordionItem) => {
                accordionItem.addEventListener('click', handleAccordionClick);
            });
        });
    }
    initSingleAccordion() {
        const accordion = document.querySelector(`.single-accordion-block-heading`);
        const content = document.querySelector(`.single-accordion-block-content`);
        accordion === null || accordion === void 0 ? void 0 : accordion.addEventListener('click', (e) => {
            const target = e.currentTarget;
            target.classList.toggle('active');
            content === null || content === void 0 ? void 0 : content.classList.toggle('show');
        });
    }
    init() {
        this.initFooterAccordion();
        this.initFAQAccordion();
        this.initSingleAccordion();
        this.initDeliveryFAQAccordion();
    }
}
